import { Box, ButtonBase, Typography } from "@material-ui/core";
import React from "react";
import { useHistory } from "react-router";
import { useRecoilValue } from "recoil";

import { PROPERTY_TYPE_VALUES } from "@/api/mappings/property";
import { Chevron } from "@/components/Chevron";
import { Loading } from "@/components/Loading";
import {
  DocumentLayout,
  DocumentLoadError,
  DocumentMissingProperty,
  useDocumentStyles,
} from "@/components/property_documents/DocumentLayout";
import { documentGroups, documentLabel } from "@/components/property_documents/documentMetadata";
import { usePropertyDocuments } from "@/components/property_documents/usePropertyDocuments";
import { NavigationPath } from "@/utilities/enums";
import { SelectedProperty } from "@/view_models/propertySelectors";

export const ManagementPropertyDocumentCategoryListPage: React.FC = () => {
  const history = useHistory();
  const classes = useDocumentStyles();
  const property = useRecoilValue(SelectedProperty);
  const { counts, loading, error, refresh } = usePropertyDocuments(property?.id);
  const consideration = property?.property?.property_type === PROPERTY_TYPE_VALUES.consideration;
  if (!property) return <DocumentMissingProperty title="物件書類" onSelect={() => history.push("/management/own")} />;
  return (
    <DocumentLayout
      title="物件書類"
      backLabel="物件詳細"
      onBack={() => history.push(consideration ? "/management/consideration/detail" : "/management/own/detail")}
      navigationPath={
        consideration ? NavigationPath.PROPERTY_MANAGEMENT_CONSIDERATION : NavigationPath.PROPERTY_MANAGEMENT_OWNED
      }
    >
      <Box className={`${classes.body} ${classes.grouped}`}>
        <Box>
          <Typography component="h2" className={classes.heading}>
            保管している書類
          </Typography>
          <Typography className={classes.small}>書類を保管しておくと、必要なときにすぐ確認できます。</Typography>
        </Box>
        {loading && counts.size === 0 ? (
          <Loading />
        ) : (
          <>
            {error && (
              <DocumentLoadError
                onRetry={() => {
                  void refresh();
                }}
              />
            )}
            {documentGroups.map((group) => (
              <Box key={group.title} className={classes.section}>
                <Typography component="h3" className={classes.sectionTitle}>
                  {group.title}
                </Typography>
                <Box className={classes.rows}>
                  {group.types.map((type) => (
                    <ButtonBase
                      key={type}
                      className={classes.row}
                      onClick={() => history.push(`/property_document/${type}`)}
                    >
                      <Typography className={classes.rowTitle}>{documentLabel(type)}</Typography>
                      <Typography className={classes.small}>
                        {counts.has(type)
                          ? counts.get(type) > 0
                            ? `${counts.get(type)}件`
                            : "なし"
                          : "取得できません"}
                      </Typography>
                      <Chevron />
                    </ButtonBase>
                  ))}
                </Box>
              </Box>
            ))}
          </>
        )}
      </Box>
    </DocumentLayout>
  );
};
